import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { collection, addDoc, serverTimestamp, doc, getDoc } from "firebase/firestore";
import { db, auth } from "../firebase";
import Header from "../components/Header";
import "../index.css"; // 전역 스타일 사용

export default function Write() {
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async () => {
    console.log("Submit button clicked"); // 버튼 클릭 로그
    console.log("Current User:", auth.currentUser); // 현재 유저 상태 로그

    if (!title.trim() || !content.trim()) {
      alert("제목과 내용을 모두 입력해주세요.");
      return;
    }

    if (!auth.currentUser) {
      console.error("User not logged in"); // 비로그인 상태 로그
      alert("로그인이 필요합니다. (로그인 상태를 확인해주세요)");
      return;
    }

    setIsSubmitting(true);

    try {
      console.log("Trying to add doc to 'posts' collection...");
      
      // 사용자 프로필 사진(Base64) 가져오기
      let authorPhoto = auth.currentUser.photoURL;
      try {
        const userDoc = await getDoc(doc(db, "users", auth.currentUser.uid));
        if (userDoc.exists() && userDoc.data().photoBase64) {
          authorPhoto = userDoc.data().photoBase64;
        }
      } catch (err) {
        console.error("Failed to fetch user profile photo:", err);
      }

      // 15초 타임아웃 설정 (네트워크 지연 대비)
      const timeoutPromise = new Promise((_, reject) => 
        setTimeout(() => reject(new Error("Timeout: 서버 응답이 너무 늦습니다 (15초 초과). Firestore 연결 상태를 확인해주세요.")), 15000)
      );

      const addDocPromise = addDoc(collection(db, "posts"), {
        title: title,
        content: content,
        author: auth.currentUser.displayName || "Anonymous",
        authorId: auth.currentUser.uid,
        authorPhoto: authorPhoto,
        createdAt: serverTimestamp(),
        likes: 0,
        comments: 0
      });

      const docRef = await Promise.race([addDocPromise, timeoutPromise]);
      
      console.log("Document written with ID: ", docRef.id);

      alert("글이 성공적으로 등록되었습니다!");
      navigate("/");
    } catch (error) {
      console.error("Error adding document FULL OBJECT: ", error); // 전체 에러 객체 출력
      
      if (error.code === "permission-denied") {
        alert(`권한 거부됨! Firestore 규칙을 다시 확인해주세요.\nError Code: ${error.code}`);
      } else {
        alert(`글 등록 실패!\nMessage: ${error.message}\nCode: ${error.code}`);
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Header />
      <main className="write-container">
        <input
          className="write-title"
          placeholder="제목을 입력하세요"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
        <textarea
          className="write-content"
          placeholder="당신의 이야기를 적어보세요..."
          value={content}
          onChange={(e) => setContent(e.target.value)}
        />
        <div className="write-footer">
          <button 
            className="btn-back" 
            onClick={() => navigate(-1)}
          >
            ← 나가기
          </button>
          <button 
            className="btn-primary" 
            onClick={handleSubmit}
            disabled={isSubmitting}
          >
            {isSubmitting ? "등록 중..." : "출간하기"}
          </button>
        </div>
      </main>
    </>
  );
}
